<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm01">
<a id="page12"></a>
<a id="page13"></a>
<div class="chapterHead">
<h2 class="chapterTitle1"><span class="bold">CHARACTERS</span></h2></div>
<div class="chapterBody">
<p class="chapterHeadA"><em class="italic">In the Country</em></p>
<div class="extract">
<p class="extractVerse">Ramona Drottoveo, <em class="italic">the albino</em></p>
<p class="extractVerse">The Signora, <em class="italic">owner of the estate, and her husband, the Signor</em></p>
<p class="extractVerse">Ovidio Gondulfo, <em class="italic">the head gardener</em></p>
<p class="extractVerse">Stiliano Mamiliano, <em class="italic">the pig keeper</em></p>
<p class="extractVerse">Ludovico Mamiliano, <em class="italic">Stiliano’s younger brother</em></p>
<p class="extractVerse">Filippo Mamiliano, <em class="italic">the boys’ father, the retired pig keeper</em></p>
<p class="extractVerse">Padre Jacopo Basolo, <em class="italic">the parish priest</em></p>
<p class="extractVerse">Blocco, <em class="italic">the old doctor</em></p>
<p class="extractVerse">Alfonsina, <em class="italic">Dr. Blocco’s wife, later marries Dr. Stipa</em></p>
<p class="extractVerse">Stipa, <em class="italic">the new doctor</em></p>
<p class="extractVerse">The beekeeper <em class="italic">(the first of three)</em></p>
<p class="extractVerse">San Ambrose, <em class="italic">patron saint of beekeepers</em></p>
<p class="extractVerse">Pupolo Floscio, <em class="italic">the pastry cook’s assistant</em></p>
<p class="extractVerse">Trofimo Barile, <em class="italic">the innkeeper at the Black Toad</em></p>
<a id="page14"></a>
<p class="extractVerse">Isolda Barile, <em class="italic">Trofimo’s wife</em></p>
<p class="extractVerse">Dalinda Scandone, <em class="italic">the kitchen maid</em></p>
<p class="extractVerse">Sant’Ursula, <em class="italic">invoked against plague</em></p>
<p class="extractVerse">Immacolata Pescatore, <em class="italic">the head cook</em></p>
<p class="extractVerse">Ernesto Conticello, <em class="italic">the rose gardener</em></p>
<p class="extractVerse">Camilla Conticello, <em class="italic">wife of the rose gardener</em></p>
<p class="extractVerse">Roberto Pedretti, <em class="italic">potboy, lover of Dalinda Scandone</em></p>
<p class="extractVerse">Ugo Rossi, <em class="italic">the under-butler</em></p>
<p class="extractVerse">Margherita Rossi, <em class="italic">wife of the under-butler</em></p>
<p class="extractVerse">Beata Viola, <em class="italic">the silver maid</em></p>
<p class="extractVerse">Rinaldo Buffi, <em class="italic">the second beekeeper</em></p>
<p class="extractVerse">Semprebene Metrofano, <em class="italic">the steward</em></p>
<p class="extractVerse">San Antonio di Padua, <em class="italic">invoked to find lost objects</em></p>
<p class="extractVerse">Santa Margherita, <em class="italic">patron saint of childbirth</em></p>
<p class="extractVerse">Floriana Redenta, <em class="italic">famous for giving birth to a piglet</em></p>
<p class="extractVerse">San Ansovinus, <em class="italic">invoked for plentiful harvests</em></p>
<p class="extractVerse">Signor Raymondo Barbuzzi, <em class="italic">dignitary in the town of Urbino</em>Signora Barbuzzi, <em class="italic">widow of the above, maker of celebrated almond</em> biscotti</p>
<p class="extractVerse">Silvestro Bernini, <em class="italic">the carpenter</em></p>
<p class="extractVerse">The beekeeper’s mother</p>
<p class="extractVerse">Virna Fuga, <em class="italic">dairymaid</em></p>
<p class="extractVerse">Tito Livio Feriani, <em class="italic">the Signor’s personal valet</em> Bernardino Bergonzoni, <em class="italic">the cowman</em></p>
<p class="extractVerse">Saturnina Floscio, <em class="italic">aunt of Pupolo</em></p>
<a id="page15"></a>
<p class="extractVerse">Bibiana Mamiliano, <em class="italic">mother of the pig men</em></p>
<p class="extractVerse">Gloriana Tomacelli, <em class="italic">the weaver</em></p>
<p class="extractVerse">Andromeda Doria, <em class="italic">the gamekeeper’s wife</em></p>
<p class="extractVerse">Milvia Lucentini, <em class="italic">the midwife</em></p>
<p class="extractVerse">Pudenziana Esposito, <em class="italic">Isolda Barile’s serving maid</em> Sant’Irina, <em class="italic">invoked for peace</em></p>
<p class="extractVerse">Vittorino Broschi, <em class="italic">the postilion</em></p>
<p class="extractVerse">Guendalina Fumagalli, <em class="italic">laundry maid, goes mad</em></p>
<p class="extractVerse">Virgin Notburga, <em class="italic">patron saint of servants</em></p>
<p class="extractVerse">San Gregorio, <em class="italic">patron saint of music</em></p>
<p class="extractVerse">San Cristoforo, <em class="italic">patron saint of journeys</em></p>
<p class="extractVerse">Selma Venerosa, <em class="italic">the cheese maker’s one-eyed assistant</em></p>
<p class="extractVerse">The lady Margherita, <em class="italic">the Signor’s married sister</em></p>
<p class="extractVerse">Contessa Magina, <em class="italic">a wedding guest</em></p>
<p class="extractVerse">The lady Lydia, <em class="italic">the Signor’s third cousin once removed</em></p>
<p class="extractVerse">Aunt Crispina, <em class="italic">the Signor’s aunt, dies during the wedding</em></p>
<p class="extractVerse">The Duc’d’Alba, <em class="italic">the Signor’s oldest friend</em></p>
<p class="extractVerse">The first Signora’s brother at Roccamonfina</p>
<p class="extractVerse">The lady Donatella, <em class="italic">wife of the above, known as the Beast of Roccamonfina</em></p>
<p class="extractVerse">Nuccio Pandolfo, <em class="italic">the third beekeeper</em></p>
<p class="extractVerse">Belinda Filippucci, <em class="italic">Ramona’s personal maid</em></p>
<p class="extractVerse">Sebaldo Metrofano, <em class="italic">son of Immacolata and Semprebene Metrofano</em></p>
<p class="extractVerse">Casto and Polo, <em class="italic">twin sons of Immacolata and Semprebene Metrofano</em></p>
<p class="extractVerse">Maurilio Bergonzoni, <em class="italic">son of the cowman</em></p>
<a id="page16"></a>
<p class="extractVerse">Silvestro Barbalace, <em class="italic">Trofimo Barile’s brother-in-law at Sparanise</em></p>
<p class="extractVerse">Perseo, <em class="italic">a young man who reeks of onions</em></p>
<p class="extractVerse">Basilio Barile, <em class="italic">son of Trofimo and Isolda Barile</em></p>
<p class="extractVerse">Tullio, <em class="italic">the Signor’s prize hunter</em></p>
<p class="extractVerse">Gordio Rossi, Gianluca Fuga, Lamberto Pedretti, <em class="italic">all suitors of Blandina</em></p>
<p class="extractVerse">San Andrea Corsini, <em class="italic">invoked against sudden death</em></p></div>
<p class="chapterHeadA"><em class="italic">In the City</em></p>
<div class="extract">
<p class="extractVerse">Nonna Pino, <em class="italic">the shrine keeper</em></p>
<p class="extractVerse">San Gennaro, <em class="italic">patron saint of Napoli</em></p>
<p class="extractVerse">Amando Castorelli, <em class="italic">landlord</em></p>
<p class="extractVerse">Rupinello, <em class="italic">the humpback</em></p>
<p class="extractVerse">Santa Casilda, <em class="italic">invoked for good luck</em></p>
<p class="extractVerse">Amalasunta Castorelli, <em class="italic">Amando Castorelli’s wife, daugher of Nonna Pino</em></p>
<p class="extractVerse">Signor Procopio Pastini, <em class="italic">an admirer of Ramona</em></p>
<p class="extractVerse">A dowager, <em class="italic">patron of the Fontana</em></p>
<p class="extractVerse">Modesta, <em class="italic">companion of the dowager</em></p>
<p class="extractVerse">Quintilla, <em class="italic">Signor Pastini’s cook</em></p>
<p class="extractVerse">Policarpo Tebaldi, <em class="italic">owner of the rag shop in the Via Acquaviva</em></p>
<p class="extractVerse">Brunella Tosti, <em class="italic">the whore who lives above Policarpo’s shop</em></p>
<p class="extractVerse">Giambattista Po, <em class="italic">the artistic director of the opera house</em></p>
<p class="extractVerse">Fanzago and Bottiglieri, <em class="italic">Signor Po’s enemies at the opera house</em></p>
<a id="page17"></a>
<p class="extractVerse">Panfilo, <em class="italic">the janitor at the opera house</em></p>
<p class="extractVerse">The Seven Sleepers of Ephesus, <em class="italic">invoked against insomnia</em></p>
<p class="extractVerse">Padre Buonconte, <em class="italic">the priest at the Chiesa di Santa Maria del Fede</em></p>
<p class="extractVerse">Santa Maria Margherita, <em class="italic">oversees the rite of exorcism</em></p>
<p class="extractVerse">Rambaldo Melandri, <em class="italic">the crib maker</em></p>
<p class="extractVerse">Everardo Donadio, <em class="italic">the ringmaster at the Donadio Brothers Circus</em></p>
<p class="extractVerse">Nabore, Valdo, and Oddo, <em class="italic">the injured man’s sons</em></p>
<p class="extractVerse">Blandina Buffi, <em class="italic">Ramona and Rinaldo’s child</em></p>
<p class="extractVerse">Signor Scarpetta, <em class="italic">a neighbor in the Via Vecchia Poggioreale</em></p>
<p class="extractVerse">Selmo Filangieri, <em class="italic">the owner of the Filangieri cook shop</em></p>
<p class="extractVerse">Monalda Spantigati, <em class="italic">the bearded lady</em></p>
<p class="extractVerse">The Great Massimo, <em class="italic">the strong man at the circus</em></p>
<p class="extractVerse">Bubbone, <em class="italic">Signor Pastini’s butler</em></p>
<p class="extractVerse">Liberio Borrelli, <em class="italic">the butcher, one of Amalasunta Castorelli’s suitors</em></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// characters.vue?c9ca0a10